import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel2';
import MatchBanner from './MatchBanner';
import { connect } from 'react-redux';
import { setBannersLoading, getBanners } from '../../../store/actions/general.actions';
import { Translate } from '../../../localization';

const options = {
  items: 1,
  nav: false,
  dots: true,
  autoplay: true,
  autoplaySpeed: 2000,
  autoplayTimeout: 10000,
  loop: true
};

const BannerCarousel = (props) => {
  const { setBannersLoading, getBanners, bannersLoading } = props;
  const adImages  = props.banners.map(ad => <div key={ `ad-ban-${ad.id}`}>  <img src={ ad.img_url } height={300} /> </div>);
  const bannerImages = props.matchBanners.map(item => <div> <MatchBanner item={ item }/> </div>);

  const history = useHistory();
  let isCasinoPage = ['casino','live-casino'].indexOf(history.location.pathname?.split('/')[2]) >= 0 ? true : false;


  useEffect(() => {
    setBannersLoading(true);
    getBanners();
  }, [])

  return (
      <div>
          { adImages.length ? 
              <OwlCarousel
                  options={ options }
              >
                  {adImages}
              </OwlCarousel>
              : (
                  bannersLoading ?
                    null
                  :
                  isCasinoPage ?
                    <div className="banner-img w-100">
                        {/* <img src="/images/casino-banner.jpg" alt="Casino banner" className='img-responsive w-100'/> */}
                        <div className='casino-banner-section'>
                            <div className='casino-banner-content text-center'>
                                <h4>USE CODE CASINO</h4>
                                <h3 className='text-uppercase'>100% Welcome Bonus <br />
                                    up to €200 <br/>
                                    PLUS 50 FREE SPINS
                                </h3>
                                <Link to='/d/promotion/casino/casino-welcome-offer'><button className='btn btn-primary text-uppercase mt-4'>{Translate.readMore}</button></Link>
                            </div>
                        </div>
                    </div>
                    :
                    <div className='sports-banner-wrap'>
                        <div className="casino-banner-content text-center">
                            <h4>USE CODE CASINO</h4>
                            <h3>EXPERIENCE THE THRILL <br/>
                                OF A REAL CASINO
                            </h3>
                        </div>
                    </div>
                )
          }
      </div>
  );
};

const mapStateToProps = (state) => {
    return {
        banners: state.general.banners,
        matchBanners: state.general.matchBanners,
        language: state.general.language,
        bannersLoading: state.general.bannersLoading,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getBanners: () => dispatch(getBanners()),
        setBannersLoading: (value) => dispatch(setBannersLoading(value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BannerCarousel);